import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import { useApiServices } from '@shared/lib/use-api-services';

export function useEmergencyGrants(withdrawalId: string | null) {
  const services = useApiServices();
  return useSWR(
    withdrawalId ? swrKeys.withdrawals.emergencyGrants(withdrawalId) : null,
    () => services.rbac.listEmergencyGrants(withdrawalId ?? ''),
    { revalidateOnFocus: false },
  );
}
